import { render, staticRenderFns } from "./88.vue?vue&type=template&id=c6dbe54e&scoped=true&"
var script = {}
import style0 from "./88.vue?vue&type=style&index=0&id=c6dbe54e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6dbe54e",
  null
  
)

export default component.exports